import React, { Component } from 'react';
import { CUSTOM_CELLS } from '../../../js/customElements/customCell';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { Logger } from '../../../js/helpers/Logger';
import { SingletonSharedData } from '../../../js/singletonSharedData';

export default class SelectComponent extends Component {
  // PROPS:
  // customCell : Nombre de la celda que lo va a mapear, esta celda deber ir en customCell.js
  // parameters : objecto con los parametros que se van a mapear en la celda
  // dataSource : array de objetos a listar
  // cellsStyles : estilo de la celda en hover
  // onSelectItem : funcion que se ejecutara cuando se seleccione una celda
  // onDisplayList : funcion que se ejecuta cuando se abren las opciones, esto se usa solo en caso de que solo un selectComponent pueda permanecer abierto
  // itemDefault : item de la lista que aparece por default
  // displayedList : Componente que esta actualmente abierto
  // displayer : Nombre del boton para desplegar la lista de opcinoes, debe esta en customComponents.js
  // defaultDiv : Nombre del div default en caso de necesitar uno especial añadir en customComponents.js => por default es un div con el texto : seleccione una opcion
  // closeOthers : En true para cerrar la lista de opciones de los demas selectComponent, en caso de que solo una pueda estar abierta
  // tag : Tag para identificar cada selectComponent que este dentro de un componente
  // bottomBox : El maximo fondo para que aparezcan las opciones, si la lista esta mas abajo se muesta para arriba, por default 0
  // maxHeigh : El maximo tamaño de la lista de opciones desplegadas
  // disabled : Si esta desabilitado el despliegue de informacion, por default false
  // styleContainer : Nombre de una clase con estilos css para el contenedor
  constructor(props) {
    super(props);
    this.state = {
      displayOptions: false,
      selectedDiv: this.props.initialSelection,
      displayedList: this.props.displayedComponent ? this.props.displayedComponent : -1,
      bottomBox: this.props.bottomBox || 0.0,
      invertedList: false,
      maxHeigh: this.props.maxHeigh || 100,
      disabled: this.props.disabled || false,
      itemProposed: null,
    }
    this.searching = "";
    this.isBlur = false;

    this.onSearching = this.onSearching.bind(this);
    this.setDataSource(this.props.dataSource);
    this.sharedData = new SingletonSharedData();
    this.isHidePhone = this.sharedData.getGeneralPermissions()[223];
    this.cellContainerRef = React.createRef();
    this.itemChange=null;
  }
  componentDidMount() {
    this.selectItemRef = this.refs["selectItem"];
    this.setSelectdedItem();
    window.addEventListener("keydown", this.onSearching, false);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps)
      if (this.props.dataSource !== nextProps.dataSource) {
        this.setDataSource(nextProps.dataSource);
        this.setSelectdedItem();
      }
    if (this.props.closeOthers && (nextProps.displayedList !== this.props.displayedList && nextProps.displayedList !== this.props.tag)) {
      this.setState({ displayOptions: false });
    }
    this.setState({ disabled: nextProps.disabled || false });
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onSearching, false);
    this.props.tag &&
      Logger.Trace(
        `[RateCall] Select Component no ´${this.props.tag}´ was visibled´`
      );
  }


  setDataSource(dataSource) {
    this.dataSource = [];
    if (this.props.parameters) {
      this.parameters = this.props.parameters;
      for (let i in dataSource) {
        let item = dataSource[i];
        item["proposed"] = false;
        this.dataSource.push(item);
      }
    } else {
      this.parameters = { text: "text" };
      for (let i in dataSource) {
        let item = dataSource[i];
        let obj = { text: item, proposed: false };
        this.dataSource.push(obj);
      }
    }  
  }
  //cellImageText: (item, parameters, cellStyles, selectCell, hidePhone) => {
  setSelectdedItem() {
    if (typeof (this.props.itemDefault) === 'number' && this.dataSource[this.props.itemDefault]) {
      this.props.onSelectItem(this.dataSource[this.props.itemDefault]);
      this.setState(this.props.customCell === 'cellImageText' ? {
        selectedDiv: CUSTOM_CELLS[this.props.customCell](this.dataSource[this.props.itemDefault], this.parameters, "transparent", null,
          this.isHidePhone),
      } : {
        selectedDiv: CUSTOM_CELLS[this.props.customCell](this.dataSource[this.props.itemDefault], this.parameters, "transparent"),
      });
    } else {
      let defaultDiv = (this.props.defaultDiv ? this.props.defaultDiv.item : "texSelection");
      let defaultText = (this.props.defaultDiv && this.props.defaultDiv.text);
      let styles = (this.props.defaultDiv && this.props.defaultDiv.styles);
      this.setState({
        selectedDiv: CUSTOM_COMPONENTS[defaultDiv](defaultText, styles),
      });
    }
  }
  /*checkInverted() {
    let rectContainer = ReactDOM.findDOMNode(this).getBoundingClientRect();
    let inverted = (rectContainer.bottom + rectContainer.height + this.state.bottomBox + this.state.maxHeigh) > window.innerHeight;
    if (inverted !== this.state.invertedList) {
      this.setState({ invertedList: inverted });
    }
  }*/
  resetProposedItem() {
    this.searching = "";
    for (let i in this.dataSource) {
      let item = this.dataSource[i];
      item["proposed"] = false;
    }
    this.setState({ itemProposed: null });
  }
  selectItem(item) {
    this.props.onSelectItem(item);
    Logger.Trace(`[Select Component] an item was selected by the agent ${item}`);
    Logger.Trace(`[Select Component][selectItem] item:  ${item}`);
    this.setState({
      selectedDiv: CUSTOM_CELLS[this.props.customCell](item, this.parameters, "transparent", null, this.isHidePhone),
      displayOptions: false
    });
    this.resetProposedItem();
  }
  displayOptions() {
    if (this.props.closeOthers) {
      this.props.onDisplayList && this.props.onDisplayList(this.props.tag)
    }
    this.resetProposedItem();
    this.selectItemRef.focus();
  }
  renderOptions() {
    let styles = { maxHeight: this.state.maxHeigh };
    return <ul ref={this.cellContainerRef} className={"listCellsSelect " + (this.state.invertedList && "inverted")} style={styles}>
      {this.dataSource.map((item) =>
        CUSTOM_CELLS[this.props.customCell](item, this.parameters, ("selectable " + (this.props.cellsStyles || "hoverGray ") + (item.proposed && (this.props.proposedStyles || "normalProposed "))), this.selectItem.bind(this), this.isHidePhone))}
    </ul>
  }
  onSearching(e) {
    if (this.state.displayOptions) {
        if (e.key === "Backspace" && e.target.tagName.toLowerCase()!="textarea") {
        Logger.Trace(`[Select Component] backspace e:${e}`);
        e.preventDefault();
      }
      if (e.key === "Enter") {
        if (this.state.itemProposed) {
          ;
          this.selectItem(this.state.itemProposed);
        }
      } else {
        this.searching += e.key;
        for (let i in this.dataSource) {
          let item = this.dataSource[i];
          item["proposed"] = false;
          for (let p in this.parameters) {
            let parameter = item[this.parameters[p]];
            if ((typeof (parameter) === 'string' || typeof (parameter) === 'number') && !parameter.toLowerCase().includes(".svg")) {//NOT SEARCH IN OBJECTS, NOT SEARCH IN SVG FILES (IMAGES)
              if (parameter.toLowerCase().startsWith(this.searching.toLowerCase()) && this.cellContainerRef) {
                Logger.Trace(`[Select Component][selectItem] onkeyDown`, e, this.cellContainerRef);
                item["proposed"] = true;
                let scroll = (parseInt(i, 10) - 1) * 25;
                this.cellContainerRef.current.scrollTo(0, scroll);
                this.setState({ itemProposed: item });
                return;
              }
            }
          }
        }
        this.resetProposedItem();
      }
    }
  }
  focus() {
    if (this.selectItemRef!==this.itemChange) {
      this.setState({ displayOptions: true });
    }
    this.selectItemRef.focus();
    if (this.props.onFocus) {
      this.props.onFocus();
    }
    let _this = this;
    setTimeout(() => { _this.isBlur = true }, 100);
    this.itemChange=this.selectItemRef;
  }
  deployOptions = () => {
    Logger.Trace(`[Select Component][selectItem] clicked!`);
    if (this.isBlur) {
      this.setState({ displayOptions: !this.state.displayOptions });
    }else{
      this.setState({ displayOptions: true });
    }
  }
  blur() {
    this.isBlur = false;
    this.setState({ displayOptions: false });
  }

  render() {
    return (
      <div className={"selectComponent " + (this.state.disabled && "disabled")} ref="selectItem" tabIndex="1" onClick={this.deployOptions} onFocus={() => this.focus()} onBlur={() => this.blur()}>
        <div className={"selectComponentContainer " + (this.props.styleContainer || "normalBorder")}>
          {CUSTOM_COMPONENTS[this.props.displayer](this.displayOptions.bind(this), this.props.stylesSelector, this.state.invertedList)}
          <div className="selectedDiv">{this.state.selectedDiv}</div>
        </div>
        {this.state.displayOptions && this.renderOptions()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/SelectComponent.jsx